import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {NachrichtFormComponent} from "../nachricht-form/nachricht-form.component";
import {AnhangMetadaten, Nachricht, NachrichtPayload} from "../../core/model/nachricht/nachricht";
import {ActivatedRoute} from "@angular/router";
import {vNiveauEnum} from "../../core/model/nachricht/vniveau.enum";
import {Subject, takeUntil} from "rxjs";
import {AnliegenHelperService} from "../anliegen-helper.service";
import {ScrollIntoView} from "../../shared/directives/scroll-into-view.directive";
import {NavigationService} from "../../shared/utils/navigation.service";
import {APP_ROUTES} from "../../route-constants";
import {NachrichtSuccessType} from "../nachricht-success-type.enum";
import {NachrichtStateEnum} from "../nachricht-state.enum";
import {HistorienElement} from "../../core/model/historien-element";
import {UserAccountService} from "../../core/services/user-account.service";

@Component({
    selector: 'kokos-nachricht-entwurf',
    imports: [
        NachrichtFormComponent,
        ScrollIntoView
    ],
    templateUrl: './nachricht-entwurf.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtEntwurfComponent implements OnInit, OnDestroy {

    nachrichtPayload: NachrichtPayload = null;

    anhangMetadaten: AnhangMetadaten[];

    nachrichtState: NachrichtStateEnum = NachrichtStateEnum.PREPARE;

    nachrichtSuccessType: NachrichtSuccessType;

    nachrichtHistorie: HistorienElement[];

    anliegenName: string;
    subanliegenName: string;
    anhangErlaubt: boolean;

    private readonly route = inject(ActivatedRoute);
    private readonly userAccountService = inject(UserAccountService);
    private readonly anliegenHelperService = inject(AnliegenHelperService);
    private readonly nav = inject(NavigationService);

    private readonly destroy$ = new Subject<void>();

    protected readonly NachrichtStateEnum = NachrichtStateEnum;


    ngOnInit(): void {

        const benutzerRechte = this.route.snapshot.data['benutzerRechte'];
        if (!benutzerRechte) {
            throw new Error('Missing benutzerRechte');
        }
        if (this.userAccountService.isRestricted()) {
            globalThis.setTimeout(() => {
                this.nav.goTo('/' + APP_ROUTES.KEIN_ONLINE_ZUGRIFF);
            }, 0);
        }

        const entwurf: Nachricht = this.route.snapshot.data['entwurf'];
        if (entwurf) {
            this.nachrichtPayload = this.createNachrichtPayload(entwurf);
            this.anhangMetadaten = entwurf.anhaengeMetadaten;
            this.retrieveAnliegen(entwurf);

        } else {
            throw new Error("Entwurf der Nachricht nicht gefunden");
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    private retrieveAnliegen(nachricht: Nachricht): void {
        this.anliegenHelperService.getAnliegenInfo(nachricht)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (anliegenNames) => {
                    this.anliegenName = anliegenNames.anliegenName
                    this.subanliegenName = anliegenNames.subanliegenName;
                    this.anhangErlaubt = anliegenNames.anhangErlaubt;
                    this.nachrichtState = NachrichtStateEnum.FORM;
                },
                error: (err) => {
                    throw err
                },
            });
    }

    private createNachrichtPayload(entwurf: Nachricht): NachrichtPayload {
        const nachrichtPayload: NachrichtPayload = {} as NachrichtPayload;
        nachrichtPayload.entwurfId = entwurf.nachrichtId;
        nachrichtPayload.vNiveau = entwurf.vNiveau ?? vNiveauEnum.DEFAULT;
        nachrichtPayload.bezug = entwurf.bezug;
        nachrichtPayload.betreff = entwurf.betreff.trim();
        nachrichtPayload.text = entwurf.text.trim();
        nachrichtPayload.empfaengerId = entwurf.dienststellennummer;
        nachrichtPayload.empfaengerName = entwurf.dienststellenname;
        this.nachrichtHistorie = entwurf.historie;
        return nachrichtPayload;
    }
}